/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import { debounce } from "debounce";

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class GoogleMap {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;
        let mapContainer = self.elem.querySelector('[data-google-map]');
        let apiKey = self.elem.getAttribute('data-key');
        let center = {
            lat: parseFloat(self.elem.getAttribute('data-lat')),
            lng: parseFloat(self.elem.getAttribute('data-lng'))
        };

        // Load the Google Maps API, passing in our API key
        loadGoogleMapsApi({ key: apiKey }).then(function (googleMaps) {

            // Create the map options
            let mapOptions = {
                zoom: 13,
                center: center,
                disableDefaultUI: true,
                zoomControl: true,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            };

            // Create the map
            let map = new googleMaps.Map(mapContainer, mapOptions);

            // Create the marker image
            let image = {
                url: '/assets/images/pm-map-marker.svg',
                scaledSize: new google.maps.Size(90, 87),
                size: new google.maps.Size(250, 242),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(62, 75)
            };

            // Create the bounds object, which will be configure later based on the marker locations
            let bounds = new googleMaps.LatLngBounds();

            // Create the marker object
            let marker = new googleMaps.Marker({
                position: center,
                map: map,
                //icon: image,
                animation: google.maps.Animation.DROP
            });

            // Work out the area of the map containing markers
            bounds.extend(marker.position);

            // Center the map on window resize
            window.onresize = debounce(centerMap, 200);

            function centerMap() {
                map.setCenter(bounds.getCenter());
            }

        }).catch(function (error) {
            console.error(error)
        });
    }
}

export default GoogleMap;